<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="from_div">
			<!--基础信息-->
			<el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="100px">
				<el-form-item label="账号姓名：" prop="nick_name">
					<el-input class="input" v-model="form.nick_name" clearable placeholder="请输入内容"/>
				</el-form-item>
				<el-form-item label="登录账号：" prop="phone">
					<el-input class="input" v-model="form.phone" clearable placeholder="请输入内容"/>
				</el-form-item>
				<el-form-item label="登录密码：" prop="password">
					<el-input class="input" v-model="form.password" clearable placeholder="默认密码:abc123456"/>
				</el-form-item>
				<el-form-item label="角色列表：" prop="group_id">
					<el-select class="select" v-model="form.group_id" clearable placeholder="角色列表">
						<el-option v-for="item in roleList" :label="item.group_name" :value="item.group_id"
							:disabled="item.group_id <= 2" />
					</el-select>
				</el-form-item>
				<el-form-item v-if="type != 1" label="指定上级：" prop="admin_pid">
					<el-select class="select" v-model="form.admin_pid" clearable placeholder="账号列表">
						<el-option v-for="item in adminList" :disabled="item.state == 2" :label="item.nick_name" :value="item.admin_id" />
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import {
		roleLists,
		adminLists,
		adminAdd,
		adminDetail,
		adminEdit
	} from "../../../request/apis.js"
	export default {
		props: {
			type: {
				type: Number
			}
		},
		components: {
			Tip
		},
		data() {
			var checkPhone = (rule, value, callback) => { //手机号码校验
				const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/
				if (!value) {
					return callback(new Error('请输入手机号作为账号'))
				}
				setTimeout(() => {
					if (!Number.isInteger(+value)) {
						callback(new Error('请输入手机号作为账号'))
					} else {
						if (phoneReg.test(value)) {
							callback()
						} else {
							callback(new Error('手机号格式不正确'))
						}
					}
				}, 100)
			}
			return {
				tip: '管理账号允许登录PC管理系统，分角色登录操作相关功能。',
				page: 1, //当前页 刷新后默认显示第一页
				limit: 10, //每一页显示的数据量 此处每页显示10条数据
				total: 0, //总条数
				roleList: [], //角色列表
				adminList: [], //账号列表
				form: {
					nick_name: '', //昵称
					phone: '', //账号
					group_id: '', //角色id
					admin_pid: '',//上级id
					password:'abc123456'//登录密码
				},
				rules: {
					nick_name: [{
							required: true,
							message: '请输入账号名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 6,
							message: '长度在6个字符内',
							trigger: 'blur'
						}
					],
					phone: [{
						required: true,
						validator: checkPhone,
						trigger: 'blur'
					}],
					password: [{
							required: true,
							message: '请输入登录密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 16,
							message: '长度在6~16个字符内',
							trigger: 'blur'
						}
					],
					group_id: [{
						required: true,
						message: '请选择角色',
						trigger: 'blur'
					}],
					admin_pid: [{
						required: true,
						message: '请选择账号',
						trigger: 'blur'
					}]
				}
			}
		},
		computed: {},
		mounted() {
			if (this.type != -1) {
				//详情编辑
				this.form.admin_id = this.type
				this.getAdminDetail();
			}
			this.getRoleList();
			this.getAdminList();
		},
		methods: {

			//查询详情
			getAdminDetail() {
				adminDetail({
					admin_id: this.form.admin_id
				}).then(res => {
					if (res.code == 0) {
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
					}
				}).catch(err => {})
			},

			//角色列表
			getRoleList() {
				roleLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.total = res.count;
						this.roleList = res.data;
					}
				}).catch(err => {})
			},

			//账号列表
			getAdminList() {
				adminLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.total = res.count;
						this.adminList = res.data;
					}
				}).catch(err => {})
			},

			//提交表单
			submitForm(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						if (this.type != -1) {
							//编辑
							adminEdit({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.$emit('close', 0)
									this.$message.success(res.msg);
								} else {
									this.$message.error(res.msg);
								}
							}).catch(err => {})
						} else {
							//新增
							adminAdd({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.$emit('close', 0)
									this.$message.success(res.msg);
								}else{
									this.$message.error(res.msg);
								}
							}).catch(err => {})
						}
					} else {
						return false;
					}
				});

			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 570px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
		margin-right: 20px;
	}

	.select {
		width: 175px;
		margin-right: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>